module.exports = __webpack_public_path__ + "static/media/personalInformation.119df811.svg";